import { useNavigate } from '@tanstack/react-router';
import { BettingWarningBanner } from 'components/betting-warning-banner';
import { Box } from 'components/Box';
import { Button } from 'components/Button';
import Icon from 'components/Icon/Icon.component';
import Navbar from 'components/Navbar/Navbar.component';
import { Typography } from 'components/typography';
import { Translate } from 'react-localize-redux';
import icon404 from './images/slot-machine.jpeg';
function NotFoundPage() {
  const navigate = useNavigate({ from: '/' });

  const handleGoBack = () => {
    navigate({ to: '/' });
  };

  return (
    <Box height={'100vh'} backgroundColor={'#fff'}>
      <BettingWarningBanner />

      <Navbar />
      <Box
        width={'100%'}
        height={'100%'}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={'24px'}
        flexDirection={{ _: 'column', lg: 'row' }}
      >
        <Box maxWidth={'456px'} width={'100%'} height={'430px'}>
          <Icon iconSrc={icon404} iconSize={'100%'} iconHeight={'100%'} />
        </Box>
        <Box display={'flex'} flexDirection={'column'} gap={'12px'}>
          <Typography variant={'displayH1'}>
            <Translate id="text.notFound.error" />
          </Typography>
          <Typography variant={'displayH2'}>
            <Translate id="text.notFound.title" />
          </Typography>
          <Typography variant={'body'} maxWidth={'456px'}>
            <Translate id="text.notFound.description" />
          </Typography>
          <Button onClick={handleGoBack}>
            <Translate id="text.notFound.backToHome" />
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export { NotFoundPage };
